export const Pagination = ({ page, totalPages, total, perPage, onPage }) => {
  if (totalPages <= 1) return null;
  const from = (page - 1) * perPage + 1;
  const to = Math.min(page * perPage, total);

  const pages = [];
  for (let i = Math.max(1, page - 2); i <= Math.min(totalPages, page + 2); i++) pages.push(i);

  return (
    <div className="pagination">
      <div className="pagination-info">Affichage {from}–{to} sur {total}</div>
      <div className="pagination-controls">
        <button className="page-btn" onClick={() => onPage(page - 1)} disabled={page === 1}>‹</button>
        {pages[0] > 1 && <><button className="page-btn" onClick={() => onPage(1)}>1</button>{pages[0] > 2 && <span style={{ color: 'var(--text3)', padding: '0 4px' }}>…</span>}</>}
        {pages.map(p => <button key={p} className={`page-btn ${p === page ? 'active' : ''}`} onClick={() => onPage(p)}>{p}</button>)}
        {pages[pages.length - 1] < totalPages && <>{pages[pages.length - 1] < totalPages - 1 && <span style={{ color: 'var(--text3)', padding: '0 4px' }}>…</span>}<button className="page-btn" onClick={() => onPage(totalPages)}>{totalPages}</button></>}
        <button className="page-btn" onClick={() => onPage(page + 1)} disabled={page === totalPages}>›</button>
      </div>
    </div>
  );
};
